export const environment = {
    production: true,
    stage: 'Staging',
    assetUrl: 'assets/images',
    opbBackendHost: 'https://api.india.uat-rocheobp.in',
    cookieDomain: '.india.uat-rocheobp.in',
    cookieBackendDomain: 'api.india.uat-rocheobp.in'
};  
